/**
 * WBA #37C — paid customization cart bridge.
 * When paid service checkboxes are selected, rewrite /cart/add to a multi-item
 * JSON payload (garment + service variants) with shared _wba_group association.
 * Also syncs service quantities to parent and removes orphan service lines.
 */
(function () {
  if (window.__anayaPaidCartBound) return;
  window.__anayaPaidCartBound = true;

  var GROUP = '_wba_group';
  var ROLE = '_wba_role';
  var SERVICE_KEY = '_wba_service_key';

  function cartAddUrl() {
    try {
      if (window.Theme && Theme.routes && Theme.routes.cart_add_url) return Theme.routes.cart_add_url;
    } catch (e) {}
    return (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js';
  }

  function cartUrl(suffix) {
    var base = '/cart';
    try {
      if (window.Theme && Theme.routes && Theme.routes.cart_url) base = Theme.routes.cart_url;
    } catch (e) {}
    return base + (suffix || '');
  }

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'wba-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function activeRoot() {
    return document.querySelector('[data-anaya-customization]');
  }

  function selectedServices(root) {
    if (!root) return [];
    return Array.prototype.slice
      .call(root.querySelectorAll('[data-anaya-paid-service]:checked'))
      .map(function (el) {
        return {
          id: Number(el.getAttribute('data-variant-id')),
          key: el.getAttribute('data-service-key') || '',
          label: el.getAttribute('data-label') || el.getAttribute('data-service-key') || 'Addition',
        };
      })
      .filter(function (s) {
        return s.id && !isNaN(s.id);
      });
  }

  function formDataToObject(fd) {
    var obj = {};
    fd.forEach(function (value, key) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        if (!Array.isArray(obj[key])) obj[key] = [obj[key]];
        obj[key].push(value);
      } else {
        obj[key] = value;
      }
    });
    return obj;
  }

  function extractProperties(raw) {
    var props = {};
    Object.keys(raw || {}).forEach(function (key) {
      var m = key.match(/^properties\[(.*)\]$/);
      if (m && raw[key] != null && String(raw[key]).trim() !== '') {
        props[m[1]] = String(raw[key]);
      }
    });
    return props;
  }

  function buildItemsFromFormData(fd, root) {
    var raw = formDataToObject(fd);
    var parentId = Number(raw.id);
    var qty = Number(raw.quantity) || 1;
    var services = selectedServices(root);
    if (!parentId || !services.length) return null;

    var group = uuid();
    var title = (root && root.getAttribute('data-product-title')) || 'Garment';
    var props = extractProperties(raw);
    props[GROUP] = group;
    props[ROLE] = 'parent';
    props['Additionals'] = services.map(function (s) { return s.label; }).join(', ');

    var items = [
      {
        id: parentId,
        quantity: qty,
        properties: props,
      },
    ];

    services.forEach(function (svc) {
      var sp = {};
      sp[GROUP] = group;
      sp[ROLE] = 'service';
      sp[SERVICE_KEY] = svc.key;
      sp['For'] = title;
      items.push({
        id: svc.id,
        quantity: qty,
        properties: sp,
      });
    });

    // outfit last in the request = first in the bag and at checkout (Shopify lists newest first)
    items.push(items.shift());
    var payload = { items: items };
    if (raw.sections) payload.sections = raw.sections;
    if (raw.sections_url) payload.sections_url = raw.sections_url;
    return payload;
  }

  function isCartAddRequest(input) {
    var url = '';
    if (typeof input === 'string') url = input;
    else if (input && typeof input.url === 'string') url = input.url;
    return url.indexOf('/cart/add') !== -1;
  }

  var originalFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    init = init || {};
    if (!isCartAddRequest(input)) {
      return originalFetch(input, init);
    }

    var root = activeRoot();
    var services = selectedServices(root);
    if (!services.length) {
      return originalFetch(input, init);
    }

    var body = init.body;
    if (!(body instanceof FormData)) {
      return originalFetch(input, init);
    }

    var payload = buildItemsFromFormData(body, root);
    if (!payload) {
      return originalFetch(input, init);
    }

    var headers = Object.assign({}, init.headers || {});
    headers['Content-Type'] = 'application/json';
    headers['Accept'] = headers['Accept'] || 'application/json';

    return originalFetch(cartAddUrl().replace(/\.js$/, '') + '.js', {
      method: 'POST',
      credentials: init.credentials || 'same-origin',
      headers: headers,
      body: JSON.stringify(payload),
    }).then(function (res) {
      return res;
    });
  };

  function prop(item, key) {
    if (!item || !item.properties) return null;
    return item.properties[key] || null;
  }

  function syncCartAssociations() {
    return originalFetch(cartUrl('.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart fetch failed');
        return r.json();
      })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return cart;
        var parents = {};
        var services = [];
        cart.items.forEach(function (item) {
          var role = prop(item, ROLE);
          var group = prop(item, GROUP);
          if (!group) return;
          if (role === 'parent') parents[group] = item;
          if (role === 'service') services.push(item);
        });

        var updates = {};
        var removes = [];

        services.forEach(function (svc) {
          var group = prop(svc, GROUP);
          var parent = parents[group];
          if (!parent) {
            removes.push(svc.key);
            return;
          }
          if (Number(svc.quantity) !== Number(parent.quantity)) {
            updates[svc.key] = parent.quantity;
          }
        });

        // If parent qty changed via UI that only updates one line, mirror to services.
        Object.keys(parents).forEach(function (group) {
          var parent = parents[group];
          services.forEach(function (svc) {
            if (prop(svc, GROUP) !== group) return;
            if (Number(svc.quantity) !== Number(parent.quantity)) {
              updates[svc.key] = parent.quantity;
            }
          });
        });

        var ops = [];
        if (Object.keys(updates).length) {
          ops.push(
            originalFetch(cartUrl('/update.js'), {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ updates: updates }),
            })
          );
        }
        removes.forEach(function (lineKey) {
          ops.push(
            originalFetch(cartUrl('/change.js'), {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: lineKey, quantity: 0 }),
            })
          );
        });

        if (!ops.length) return cart;
        return Promise.all(ops).then(function () {
          return originalFetch(cartUrl('.js'), {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
          }).then(function (r) {
            return r.json();
          }).then(function (updated) {
            refreshCart(updated);
            return updated;
          });
        });
      })
      .catch(function () {
        /* non-fatal */
      });
  }

  // The bag was drawn before the extras were synced: update the bag count, then ask the bag to redraw.
  // cart-items-component redraws on this event (no sections given = it fetches its own).
  // Not import(): Shopify's asset minifier rewrites it to require(), which fails in the browser.
  // The sync these events trigger finds nothing left to change, so it stops there.
  function refreshCart(cart) {
    if (cart) {
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'anaya-paid-customization', data: { itemCount: cart.item_count } },
        })
      );
    }
    setTimeout(function () {
      var redraw = new Event('shopify:cart:lines-update', { bubbles: true });
      redraw.promise = Promise.resolve({ detail: {} });
      document.dispatchEvent(redraw);
    }, 400);
  }

  var syncTimer = null;
  function scheduleSync() {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(syncCartAssociations, 350);
  }

  document.addEventListener('cart:update', scheduleSync, { passive: true });
  document.addEventListener('shopify:cart:lines-update', scheduleSync, { passive: true });
  document.addEventListener('DOMContentLoaded', scheduleSync);
})();
